import { CreateNS } from '../lib/createAPIBuilder';

export const installAPINavigation = (namespace: CreateNS) => {
    namespace('navigation')(({ prop, deps }) => {
        prop('initialUrl', deps.getInitialUrl, null);
        prop('initialUrlParameters', deps.getInitialUrlParameters, null);
    });
};
